import Vue from 'vue';

export const MOBILE_BREAKPOINT = 768;

const state = Vue.observable({ isMobile: false });

function updateMobile() {
  state.isMobile = window.innerWidth < MOBILE_BREAKPOINT;
}

if (typeof window !== 'undefined') {
  updateMobile();
  window.addEventListener('resize', updateMobile);
}

export default {
  computed: {
    isMobile() {
      return state.isMobile;
    },
  },
};
